/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ruler': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M793.2 80.7L80.7 793.2c-15 15-15 39.4 0 54.4l71.8 71.8c15 15 39.4 15 54.4 0L919.4 206.8c15-15 15-39.4 0-54.4L847.6 80.7c-15-15-39.4-15-54.4 0zM196.3 880.8L119.3 803.8 220.5 702.6l38.5 38.5c7.5 7.5 19.7 7.5 27.2 0 7.5-7.5 7.5-19.7 0-27.2L247.7 675.4 313.6 609.5 388 683.9c7.5 7.5 19.7 7.5 27.2 0 7.5-7.5 7.5-19.7 0-27.2l-74.5-74.4 65.9-65.9 38.5 38.5c7.5 7.5 19.7 7.5 27.2 0 7.5-7.5 7.5-19.7 0-27.2L433.8 489.2 499.7 423.3l74.5 74.4c7.5 7.5 19.7 7.5 27.2 0 7.5-7.5 7.5-19.7 0-27.2l-74.4-74.4 65.9-65.9 38.5 38.5c7.5 7.5 19.7 7.5 27.2 0 7.5-7.5 7.5-19.7 0-27.2L619.9 303.0 685.8 237.1 760.3 311.6c7.5 7.5 19.7 7.5 27.2 0 7.5-7.5 7.5-19.7 0-27.2l-74.5-74.5 88.0-88.0 76.9 76.9L196.3 880.8z"/>'
  }
})
